import { useEffect } from "react";

const BUILD_CHECK_INTERVAL_MS = 10 * 60 * 1000; // 10 minutes

export const useBuildCheck = (locationPathname) => {
	useEffect(() => {
		let reloadTimeout;

		if (
			typeof sessionStorage === "undefined" ||
			!sessionStorage ||
			sessionStorage === null ||
			typeof window === "undefined"
		) {
			return;
		}
		const BUILD_HASH = `BUILD_HASH-${window.location.origin}`;
		const BUILD_HASH_TIME = `BUILD_HASH_TIME-${window.location.origin}`;
		const LAST_BUILD_CHECK = `LAST_BUILD_CHECK-${window.location.origin}`;

		const checkBuild = async () => {
			try {
				const res = await fetch("/build-hash", { cache: "no-store" });

				const serverHash = res.headers.get("X-Build-Hash");
				const clientHash = sessionStorage.getItem(BUILD_HASH);

				const serverHashTime = parseInt(
					res.headers.get("X-Build-Time"),
					10,
				);
				const clientHashTime =
					parseInt(sessionStorage.getItem(BUILD_HASH_TIME), 10) || 0;

				if (
					serverHash &&
					clientHash &&
					serverHash !== clientHash &&
					serverHashTime > clientHashTime
				) {
					sessionStorage.setItem(BUILD_HASH, serverHash);
					sessionStorage.setItem(BUILD_HASH_TIME, serverHashTime);

					reloadTimeout = setTimeout(() => {
						if (typeof window !== "undefined") {
							window.location.reload();
						}
					}, 500);
				} else {
					sessionStorage.setItem(BUILD_HASH, serverHash);
					sessionStorage.setItem(BUILD_HASH_TIME, serverHashTime);
				}
				sessionStorage.setItem(LAST_BUILD_CHECK, Date.now());
			} catch (err) {
				console.error("Build check failed", err);
			}
		};

		const lastCheck =
			parseInt(sessionStorage.getItem(LAST_BUILD_CHECK), 10) || 0;
		const now = Date.now();

		if (now - lastCheck > BUILD_CHECK_INTERVAL_MS) {
			checkBuild();
		}

		const handleBeforeUnload = () => {
			sessionStorage.removeItem(BUILD_HASH);
			sessionStorage.removeItem(BUILD_HASH_TIME);
			sessionStorage.removeItem(LAST_BUILD_CHECK);
		};

		window.addEventListener("beforeunload", handleBeforeUnload);
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
			if (reloadTimeout) {
				clearTimeout(reloadTimeout);
			}
		};
	}, [locationPathname]);
};
